import {createContext} from 'react';
import {AuthUser, JWT} from 'aws-amplify/auth';
import {AuthStatus} from '@flexinet/auth-components';

export type AuthContextType = {
    user: AuthUser | undefined,
    // FNP-1727: whether the session has been RESOLVED yet, which `user` alone
    // cannot express. 'resolving' until the user and session lookups both
    // settle, then 'authenticated' or 'anonymous'. Fed to the shared
    // VerifiedPermissionsProvider as its sessionStatus.
    status: AuthStatus,
    idToken?: JWT | undefined,
    accessToken?: JWT | undefined,
    cognitoGroups?: string[] | undefined,
    role?: string | undefined,
}

export const AuthContext = createContext<AuthContextType>({
                                                              user: {} as AuthUser,
                                                              // Not 'anonymous': outside the provider this context
                                                              // cannot claim nobody is signed in.
                                                              status: 'resolving',
                                                          });
